import { render, staticRenderFns } from "./alpay.vue?vue&type=template&id=744c8a0d&"
import script from "./alpay.vue?vue&type=script&lang=js&"
export * from "./alpay.vue?vue&type=script&lang=js&"
import style0 from "./alpay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports